(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("scormService", ["$rootScope", "$translate", "$window", "authService", "assignmentLearnerAccessOnlineLessonResource", scormService]);
    function scormService($rootScope, $translate, $window, authService, assignmentLearnerAccessOnlineLessonResource) {
        var scormServiceFactory = {};
        var model = {};
        var onlineLessonModel = {};
        var lastError = 0;
        var dataCommited = false;
        var sessionStartDate;
        var initialized = false;
        var finished = false;
        var lastCommitedData = "";
        var errorKeyPrefix;
        var diagnosticKeyPrefix;
        var isPreview = false;
        function init(onlineLesson, previewMode) {
            onlineLessonModel = onlineLesson;
            initialized = false;
            finished = false;
            lastCommitedData = "";
            if (previewMode)
                isPreview = previewMode;
            scormServiceFactory.data = !onlineLessonModel.data ? {} : JSON.parse(onlineLessonModel.data);
            scormServiceFactory.version = onlineLessonModel.version;
            if (scormServiceFactory.version === '1.2') {
                initV12();
            }
            else {
                initV2004();
            }
        }
        function initV12() {
            errorKeyPrefix = "common.scorm.error.v12.";
            diagnosticKeyPrefix = "common.scorm.diagnostic.v12.";
            $window.API = null;
            $window.API = {
                LMSInitialize: initialize,
                LMSFinish: terminate,
                LMSGetValue: getValue,
                LMSSetValue: setValue,
                LMSCommit: commit,
                LMSGetLastError: getLastError,
                LMSGetErrorString: getErrorString,
                LMSGetDiagnostic: getDiagnostic
            };
        }
        function initV2004() {
            errorKeyPrefix = "common.scorm.error.v2004.";
            diagnosticKeyPrefix = "common.scorm.diagnostic.v2004.";
            $window.API_1484_11 = null;
            $window.API_1484_11 = {
                Initialize: initialize,
                Terminate: terminate,
                GetValue: getValue,
                SetValue: setValue,
                Commit: commit,
                GetLastError: getLastError,
                GetErrorString: getErrorString,
                GetDiagnostic: getDiagnostic
            };
        }
        //#region Scorm functions
        function initialize(param) {
            if (finished)
                return "true";
            if (initialized) {
                setError(101, 103);
                return "false";
            }
            if (param !== "") {
                setError(201, 201);
                return "false";
            }
            initialized = true;
            if (!scormServiceFactory.data)
                scormServiceFactory.data = {};
            lastError = 0;
            dataCommited = false;
            sessionStartDate = new Date();
            model = {
                id: onlineLessonModel.assignmentId,
                activationId: onlineLessonModel.activationId
            };
            return "true";
        }
        function terminate() {
            if (finished) {
                setError(101, 113);
                return "false";
            }
            if (!initialized) {
                setError(301, 112);
                return "false";
            }
            if (scormServiceFactory.data["cmi.core.exit"] === "" || scormServiceFactory.data["cmi.exit"] === "") {
                scormServiceFactory.data = null;
                dataCommited = false;
            }
            if (!dataCommited)
                commit();
            $rootScope.$broadcast("onlineLessonTerminated");
            finished = true;
            return dataCommited.toString();
        }
        function getValue(element) {
            if (finished) {
                setError(301, 123);
                return "false";
            }
            if (!initialized) {
                setError(301, 122);
                return "false";
            }
            var value;
            switch (element) {
                case "cmi.core._children":
                    return "student_id, student_name, lesson_location, credit, lesson_status, entry, score, total_time, lesson_mode, exit, session_time, RO";
                case "cmi.learner_id":
                case "cmi.core.student_id":
                    return authService.authentication.userPersonSeq;
                case "cmi.learner_name":
                case "cmi.core.student_name":
                    return authService.authentication.userLastName + ", " + authService.authentication.userFirstName;
                default:
                    value = scormServiceFactory.data[element];
                    break;
            }
            if (!value)
                value = "";
            lastError = 0;
            return value;
        }
        function setValue(element, value) {
            if (finished) {
                setError(301, 133);
                return "false";
            }
            if (!initialized) {
                setError(301, 132);
                return "false";
            }
            switch (element) {
                case "cmi.completion_status":
                case "cmi.core.lesson_status":
                    model.lessonStatus = value;
                    break;
                case "cmi.score.raw":
                case "cmi.core.score.raw":
                    model.rawScore = value;
                    break;
                case "cmi.score.max":
                case "cmi.core.score.max":
                    model.maxScore = value;
                    break;
                case "cmi.session_time":
                case "cmi.core.session_time":
                    model.totalTime = value;
                    break;
            }
            scormServiceFactory.data[element] = value;
            lastError = 0;
            dataCommited = false;
            return "true";
        }
        function commit() {
            if (finished) {
                setError(301, 143);
                return "false";
            }
            if (!initialized) {
                setError(301, 142);
                return "false";
            }
            if (isPreview) {
                //Don't persist data if we are previewing the course
                dataCommited = true;
                return "true";
            }
            model.data = JSON.stringify(scormServiceFactory.data);
            if (lastCommitedData !== model.data) {
                lastCommitedData = model.data;
                assignmentLearnerAccessOnlineLessonResource.commitScormData(model, function () { }, function (error) {
                    console.error(error);
                    setError(101, 391);
                });
            }
            dataCommited = true;
            return "true";
        }
        function getLastError() {
            return lastError.toString();
        }
        function getErrorString(errorCode) {
            var errorKey = errorKeyPrefix + errorCode;
            var errorString = $translate.instant(errorKey);
            if (errorString === errorKey)
                errorString = $translate.instant("common.scorm.error.101");
            return errorString;
        }
        function getDiagnostic(errorCode) {
            var errorKey = diagnosticKeyPrefix + errorCode;
            var errorString = $translate.instant(errorKey);
            if (errorString === errorKey)
                return "";
            return errorString;
        }
        //#endregion
        function setError(v12ErrorCode, v2004ErrorCode) {
            if (scormServiceFactory.version === '1.2')
                lastError = v12ErrorCode;
            else
                lastError = v2004ErrorCode;
        }
        scormServiceFactory.init = init;
        return scormServiceFactory;
    }
}());
